// https://github.com/InsuranceTechnologySolutions/its-validation/blob/master/Its.Validation/AttachmentsFileNameValidator.cs
const imageExtensions = ['.jpg', '.jpeg', '.jfif', '.bmp', '.gif', '.tiff', '.tif', '.png'];
const videoExtensions = ['.mp4', '.mpeg', '.mpg', '.mov'];
const documentExtensions = ['.pdf', '.doc', '.docx', '.docm', '.ppt', '.pptx', '.txt', '.rtf', '.xls', '.xlsx', '.xlsb', '.xlsm', '.csv'];
const otherExtensions = ['.zip', '.htm', '.html', '.ics', '.msg', '.eml'];

export const allowedFileTypes = [...imageExtensions, ...videoExtensions, ...otherExtensions, ...documentExtensions].join(', ');
